<template>
  <div class="latest-news-widget">
    <div class="latest-news-widget__header">
      <h2>{{ title }}</h2>
      <a
        class="text-base is-alternative"
        :href="newsOverviewUrl"
      >{{ i18n.links.moreNews }}</a>
    </div>
    <slot />
    <p
      v-if="!areThereNewsItemsPresent"
      class="italic"
    >
      {{ i18n.text.noNewsItemsAvailable }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'LatestNewsWidget',
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    newsOverviewUrl: {
      type: String,
      default: '#',
    },
  },
  computed: {
    areThereNewsItemsPresent() {
      return !!this.$slots.default;
    },
  },
};
</script>

<style lang="postcss">
.latest-news-widget {
  &__header {
    @apply flex items-baseline justify-between;
  }
}
</style>
